package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_03_01_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who have just teleported back to Malus. It is late at night, and Tuesday updates Brauna Hollytoes on the heroes’ adventures in the desert. Brauna stables Flower and prepares rooms for the heroes.  The heroes go up the stairs to their rooms to await Master Danvid, leader of the Powerglow guild. Tuesday asks Falorn about Anarin Conlan. When master Danvid arrives and asks them about their trip, the heroes only give a vague answer, since they would prefer to update the complete Roving Peers and Malusian leadership on their progress collectively.")
    }
}
